import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Me ahorró meses de trabajo. Las clases están perfectamente organizadas y los alumnos participan mucho más. La mejor inversión para mi carrera docente.',
  name: 'María L.',
  location: 'Buenos Aires',
  avatar: 'M'
}, {
  quote: 'Por fin encontré un recurso completo para Administración. La planificación anual es un lujo y los casos prácticos están súper actualizados.',
  name: 'Carlos R.',
  location: 'Córdoba',
  avatar: 'C'
}, {
  quote: 'Lo mejor es que está todo listo para usar. Solo lo adapto un poco a mi grupo y ya tengo la clase armada. Me devolvió mis fines de semana.',
  name: 'Laura S.',
  location: 'Mendoza',
  avatar: 'L'
}];
export function Testimonials() {
  return <section id="testimonios" className="py-24 bg-gray-50" data-id="element-208">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-209">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-16" data-id="element-210">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-211">
            Lo que dicen otros docentes
          </h2>
          <div className="w-24 h-1 bg-accent mx-auto rounded-full" data-id="element-212" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-213">
          {testimonials.map((test, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 relative" data-id="element-214">
              <QuoteIcon className="absolute top-6 right-6 w-12 h-12 text-gray-100" data-id="element-215" />

              <div className="flex gap-1 mb-6 relative z-10" data-id="element-216">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-accent text-accent" data-id="element-217" />)}
              </div>

              <p className="text-gray-700 text-lg italic mb-8 relative z-10 leading-relaxed" data-id="element-218">
                "{test.quote}"
              </p>

              <div className="flex items-center gap-4 border-t border-gray-100 pt-6" data-id="element-219">
                <div className="w-12 h-12 rounded-full bg-primary-light/20 text-primary-dark font-bold flex items-center justify-center text-xl" data-id="element-220">
                  {test.avatar}
                </div>
                <div data-id="element-221">
                  <h4 className="font-bold text-gray-900" data-id="element-222">{test.name}</h4>
                  <p className="text-sm text-gray-500" data-id="element-223">
                    Docente en {test.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}